import React, { Children, createContext, useContext, useEffect, useState } from 'react'
import { getCustomerToken } from '../apis/authApi'
 
const AuthContext = createContext()

const AuthProvider = ({children}) => {
  const [isLogin,setLogin] = useState(false)
  const [user,setUser] = useState(null)

  useEffect(()=>{
    getCustomerToken().then((res)=>{
      setUser(res.data)
      setLogin(true)
    }).catch((err)=>{
      setUser(null)
      setLogin(false)
    })
  },[isLogin])
  return ( 
    <AuthContext.Provider value={{isLogin,setLogin,user,setUser}}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = ()=>{
  return useContext(AuthContext)
}

export default AuthProvider